var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinesMdinline = function SvgLinesMdinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 625,
    height: 201,
    viewBox: "0 0 625 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M624 0c0 35.376-25.822 65.457-60.791 70.814L403.957 95.216C352.073 103.165 313.577 147.514 313 200M1 0c0 35.364 25.84 65.421 60.804 70.727l162.22 24.618C275.623 103.175 313.573 147.813 313 200",
    stroke: "#C7C4D4"
  })));
};
export default SvgLinesMdinline;